
import _debounce from 'lodash.debounce'
export default {
  props: {
    module: Object,
    group: Object,
  },

  data() {
    return {
      isReady: false,
      template: {
        headlineContact: {
          label: 'form.yourData',
          module: 'headline',
        },
        firstName: {
          label: 'form.label.firstName',
          module: 'text',
          required: true,
        },
        lastName: {
          label: 'form.label.lastName',
          module: 'text',
        },
        eMail: {
          label: 'form.label.mail',
          module: 'text',
          pattern: /.+@.+\..+/,
          error: 'form.validation.eMail',
          valid: true,
          required: true,
        },
        phoneNumber: {
          label: 'form.label.phone',
          module: 'text',
          pattern: /^[0-9\ \+]*$/,
          error: 'form.validation.phoneNumber',
          valid: true,
        },
        installation: {
          label: 'form.label.installation',
          module: 'text',
          error: 'form.validation.text',
          valid: true,
        },
        termsAndConditions: {
          label: '',
          module: 'info',
        },
        // acceptTerms: {
        //   label: 'Ja, ich habe die Datenschutzerklärung gelesen und akzeptiere diese.',
        //   module: 'checkbox'
        // }
      },
    }
  },

  watch: {
    group: {
      handler: _debounce(function (val) {
        if (val) {
          if (val.eMail) {
            if (this.template.eMail.pattern.test(val.eMail)) {
              this.template.eMail.valid = true
            } else {
              this.template.eMail.valid = false
            }
          }

          if (val.phoneNumber) {
            if (this.template.phoneNumber.pattern.test(val.phoneNumber)) {
              this.template.phoneNumber.valid = true
            } else {
              this.template.phoneNumber.valid = false
            }
          } else {
            this.template.phoneNumber.valid = true
          }

          // console.log(val.desiredInstallation)
          // if (val.desiredInstallation) {
          //   this.template.desiredInstallation.valid = true
          // } else {
          //   this.template.desiredInstallation.valid = false
          // }

          if (
            val.firstName &&
            val.eMail /* && val.lastName  && val.installation && val.acceptTerms */
          ) {
            if (this.template.eMail.pattern.test(val.eMail)) {
              this.$emit('valid', true)
            } else {
              this.$emit('valid', false)
            }
          } else {
            this.$emit('valid', false)
          }
        }
      }, 400),
      deep: true,
      immediate: true,
    },
  },

  computed: {
    _group: {
      set(value) {
        this.$emit('update:group', value)
      },

      get() {
        return this.group
      },
    },
  },

  mounted() {
    if (!this.group) this._group = {}
    this.template.headlineContact.label = this.module.content.headlineContact
    this.template.termsAndConditions.label =
      this.module.content.termsAndConditions
    this.isReady = true
  },
}
